/* eslint-disable react/display-name */
import { disabledSelector } from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSDisabledProps {
  disabled: boolean;
}

export const withFormJSDisabled =
  <P extends EntityId & WithFormJSDisabledProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'disabled'>) => {
    const disabled = useSelector(disabledSelector(props.id));
    return <Component {...(props as P)} disabled={disabled} />;
  };
